/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-21 16:34:31
 */
import * as Vue from 'vue-tsx-support';

import { Component } from 'vue-property-decorator';
import './synthesizeReport.less';
import { createNamespace, createBEM } from 'src/util/bem';
import StationTree from 'src/components/stationTree/stationTree';
import FrameSideBg from 'src/pages/layout/components/frameSideBg';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import SynthesizeReportComponent from '../singleStationReport/synthesizeReport/synthesizeReport';
import StationSider from 'src/pages/stationDetail/component/stationSider';
let bem = createBEM('synthesize-report');

@Component({ name: 'synthesize-report' })
export default class SynthesizeReport extends Vue.Component<any> {
    ids: number[] = [];

    multipleChange(mns, data: StationListDOI.RowDataI[]) {
        this.ids = data.map(i => i.id);
    }
    type: string = '';
    async typeChnage(type: string) {
        this.type = type;
    }

    async mounted() {
        let stationTree: StationSider = this.$refs.stationTree as StationSider;
        let station = await stationTree.getStations();
        this.ids = [station[0].id];
        stationTree.clearCheckedNode();
        // @ts-ignore
        station[0].checked = true;
        stationTree.openNodeByMn(station[0].mn);
    }
    render(h) {
        return (
            <layout class={bem()}>
                <sider hide-trigger width={372} class={createNamespace('pa6')}>
                    {/* <FrameSideBg style="height: 100%">
                        <div class={[createNamespace(['pa10']), bem('tree-wrapper')]}>
                            <StationTree
                                class={createNamespace(['mt10', 'mb10'])}
                                ref="stationTree"
                                showCheckBox
                                on-check-change={this.multipleChange.bind(this)}
                            />
                        </div>
                    </FrameSideBg> */}
                    <StationSider
                        class={createNamespace(['mt10', 'mb10'])}
                        ref="stationTree"
                        showCheckBox
                        on-check-change={this.multipleChange.bind(this)}
                    />
                </sider>
                <i-content class={bem('content') + ' ' + createNamespace('pa6')}>
                    <SynthesizeReportComponent ids={this.ids} />
                    {/* <MonthReport v-if={this.currentReport==='月报'} on-change={v=> this.currentReport = v}></MonthReport> */}
                </i-content>
            </layout>
        );
    }
}
